import { AuthConstant } from "../shared/constants/all-constant";
import { apiEndpoints } from "../shared/constants/api-constant";
import { AppConfigurationHelper } from "./AppConfigurationHelper";
import restApiService from "./restApiService";
import axios from "axios";

export class sessionRepository {
  static Logout = async (): Promise<boolean> => {
    let result = false;
    await restApiService
      .post(apiEndpoints.LOGOUT, null)
      .then((response) => {
        result = response?.status === 200;
        localStorage.removeItem(AuthConstant.AUTH_TOKEN);
      })
      .catch((error) => {
        console.log("exception on API call : " + error);
      });
    return result;
  };

  static Login = async (loginPayload: any): Promise<any> => {
    let token = "";
    let result: any = null;
    await axios
      .post(
        `${process.env.REACT_APP_API_URL}${apiEndpoints.LOGIN}`,
        loginPayload,
        {
          timeout: AppConfigurationHelper.Instance().APITimeOutInSeconds * 1000,
        }
      )
      .then((response) => {
        result = response.data.data;
      })
      .catch((error) => {
        console.log("exception on API call : ", error);
        //error. network error case
        if (error.code === "ECONNABORTED" || error.code === "ERR_NETWORK") {
          result = {
            code: "408",
            message: "Request is timed out. Please check your connection.",
          };
        } else {
          result = {
            code: "",
            message: error?.response,
          };
        }
        return result;
      });
    return result;
  };
}
